<template>
  <div>
    <main-layout>
      <MainMenu />
      <v-container>
        <div class="mb-2">
          <h1>{{ $t('seminar_booking_list') }}</h1>
        </div>
        <v-layout wrap class="pt-4">
          <v-flex xs12 sm6>
            <multiselect
              v-model="filterSeminar"
              :options="seminarOptions"
              label="label"
              select-label
              selected-label
              track-by="value"
              placeholder="เลือกสัมมนา"
              @input="handleResetAndFetchData"
            ></multiselect>
          </v-flex>
          <v-flex xs12 sm6 class="text-sm-right text-xs-right">
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
            <v-btn dark outline color="primary" :loading="exportLoading" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <div
              v-if="showAdvancedSearch"
              class="mt-2 mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs12 sm6 px-2>
                  <div class="caption">Channel</div>
                  <v-radio-group
                    v-model="filter.app"
                    color="primary"
                    row
                    class="text-xs-center mt-0"
                  >
                    <v-radio color="primary" :label="$t('All')" value=""></v-radio>
                    <v-radio color="primary" :label="$t('facebook')" :value="'facebook'"></v-radio>
                    <v-radio color="primary" :label="$t('line')" :value="'line'"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6 px-2>
                  <div class="caption">สถานะ</div>
                  <v-radio-group
                    v-model="filter.booking_status"
                    color="primary"
                    row
                    class="text-xs-center mt-0"
                  >
                    <v-radio color="primary" :label="$t('All')" value=""></v-radio>
                    <v-radio color="primary" :label="'จองสำเร็จ'" :value="'active'"></v-radio>
                    <v-radio color="primary" :label="'ยกเลิกการของ'" :value="'inactive'"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6 px-2>
                  <div class="caption">Social Name</div>
                  <input v-model="filter.social_name" type="text" placeholder="Social Name" />
                </v-flex>

                <v-flex xs12 sm6 px-2>
                  <div class="caption">ชื่อลูกค้า</div>
                  <input v-model="filter.user_name" type="text" placeholder="ชื่อลูกค้า" />
                </v-flex>
                <v-flex xs12 sm6 px-2>
                  <div class="caption">เบอร์โทรศัพท์</div>
                  <input v-model="filter.phone_number" type="text" placeholder="เบอร์โทรศัพท์" />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  style="display: flex; justify-content: flex-end; align-items: flex-end"
                >
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed color="primary" @click="handleSearch">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <div v-if="filterSeminar" class="text-xs-right py-2">
          จำนวนที่นั่งคงเหลือ
          <span style="font-size: 20px"
            ><span class="primary--text">{{ totalBookingSeats }}</span
            >/<span>{{ totalSeats }}</span></span
          >
        </div>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="dataItems"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template slot="headerCell" slot-scope="props">
            <HeaderTableWithSort
              :headers="props.header"
              :sort-by.sync="sortBy"
              :order-by.sync="orderBy"
              @onSort="handleChangeSort"
            ></HeaderTableWithSort>
          </template>
          <template #items="props">
            <tr>
              <td>{{ props.item.seminar_name || '-' }}</td>
              <td>{{ props.item.social_name || '-' }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.app == 'facebook'" style="color: #3b5998">
                  <em class="fab fa-facebook-square" />
                </span>
                <span v-else-if="props.item.app == 'line'" style="color: #00c300">
                  <em class="fab fa-line" />
                </span>
              </td>
              <td>{{ props.item.user_name || '-' }}</td>
              <td>{{ props.item.phone_number || '-' }}</td>
              <td>{{ props.item.booking_date | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td>
                <span :class="props.item.booking_status === 'active' ? 'green--text' : 'red--text'">
                  {{ props.item.booking_status === 'active' ? 'จองสำเร็จ' : 'ยกเลิกการจอง' }}
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pageLength"
            @input="handleChangePage"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import mainAiraApi from '@/api/aira.js'
import MainMenu from './MainMenu.vue'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import { handleResponse, handleApiError } from '@/api/util'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'
import dayjs from 'dayjs'

export default {
  components: {
    MainMenu,
    HeaderTableWithSort,
    Multiselect
  },
  data() {
    return {
      showAdvancedSearch: false,
      exportLoading: false,
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      dataItems: [],
      headers: [
        { text: 'Seminar Name', value: 'seminar_name', sortable: false, customSort: false },
        { text: 'Social Name', value: 'social_name', sortable: false, customSort: false },
        { text: 'Channel', value: 'app', sortable: false, customSort: false, align: 'center' },
        { text: 'ชื่อลูกค้า', value: 'user_name', sortable: false, customSort: false },
        { text: 'เบอร์โทรศัพท์', value: 'phone_number', sortable: false, customSort: false },
        { text: 'เวลาจองสัมมนา', value: 'booking_date', sortable: false, customSort: true },
        { text: 'สถานะ', value: 'booking_status', sortable: false, customSort: false }
      ],
      filterSeminar: null,
      filter: {
        app: '',
        booking_status: '',
        social_name: '',
        user_name: '',
        phone_number: ''
      },
      isExport: false,
      sortBy: 'booking_date',
      orderBy: ORDER_BY.DESC,
      dataSeminarList: [],
      totalBookingSeats: 0,
      totalSeats: 0
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageLength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    seminarOptions() {
      let options = []
      options = this.dataSeminarList.map((seminar) => {
        return {
          label: seminar.seminar_name,
          value: seminar.seminar_id
        }
      })
      return options
    },

    query() {
      return this.$route.query
    }
  },
  async mounted() {
    await this.getSeminar()

    if (this.query && this.query.id) {
      this.filterSeminar = this.seminarOptions.find((item) => item.value === this.query.id)
    }

    await this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getBookingList()
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200) {
          vm.dataItems = response.data.data
          vm.total = response.data.total

          vm.totalBookingSeats =
            vm.dataItems && vm.dataItems.length > 0 ? vm.dataItems[0].seat_count : 0
          vm.totalSeats = vm.dataItems && vm.dataItems.length > 0 ? vm.dataItems[0].seats : 0
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getBookingList() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        if (vm.filterSeminar) {
          Object.assign(data, { seminar_id: vm.filterSeminar.value })
        }
        if (vm.filter.app) {
          Object.assign(data, { app: vm.filter.app })
        }
        if (vm.filter.booking_status) {
          Object.assign(data, { status: vm.filter.booking_status })
        }

        if (vm.filter.social_name) {
          Object.assign(data, { social_name: vm.filter.social_name })
        }
        if (vm.filter.user_name) {
          Object.assign(data, { user_name: vm.filter.user_name })
        }
        if (vm.filter.phone_number) {
          Object.assign(data, { phone_number: vm.filter.phone_number })
        }

        if (vm.sortBy) {
          let sortByKey = ''

          if (vm.sortBy === 'booking_date') {
            sortByKey = 'sort_date'
          }

          Object.assign(data, { [sortByKey]: vm.orderBy })
        }

        vm.$store.dispatch('loading')
        const response = await mainAiraApi.getBookingSeminar({
          config: data
        })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getBookingList()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            seminar_name: el.seminar_name,
            social_name: el.social_name,
            app: el.app,
            user_name: el.user_name,
            phone_number: el.phone_number,
            booking_date: el.booking_date ? dayjs(el.booking_date).format('DD/MM/YYYY HH:mm') : '-',
            booking_status: el.booking_status === 'active' ? 'จองสำเร็จ' : 'ยกเลิกการจอง'
          }
        })

        const heading = [
          [
            'Seminar Name',
            'Social Name',
            'Channel',
            'ชื่อลูกค้า',
            'เบอร์โทรศัพท์',
            'เวลาจองสัมมนา',
            'สถานะ'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `seminar-booking-list.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchData()
      }
    },
    handleSearch() {
      this.handleResetAndFetchData()
    },
    handleClearSearch() {
      this.filter = {
        app: '',
        booking_status: '',
        social_name: '',
        user_name: '',
        phone_number: ''
      }
      this.handleResetAndFetchData()
      this.handleCloseSearch()
    },
    handleResetAndFetchData() {
      this.totalBookingSeats = 0
      this.totalSeats = 0
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleFetchData()
    },
    handleChangeSort() {
      this.handleFetchData()
    },
    async getSeminar() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: 50,
          offset: 0
        }

        vm.$store.dispatch('loading')
        const response = await mainAiraApi.getSeminar({
          config: data
        })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response && response.status === 200) {
          vm.dataSeminarList = response.data.data
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/BookingList.vue